import { render, staticRenderFns } from "./LottoPage.vue?vue&type=template&id=67f57743&"
import script from "./LottoPage.vue?vue&type=script&lang=js&"
export * from "./LottoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports